export default __webpack_public_path__ + "static/media/unity.9f1683be.svg";